<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Drive Assembly</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (motorTypeSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Motor Type:</label>
            <select class="halfWidthInputField" #motorTypeInput
              [class.invalidConfigurationSelection]="isInvalidSelection(motorTypeSelection.Name)"
              (change)="selectionChanged(motorTypeSelection, motorTypeInput.value)"
              [value]="motorTypeSelection.Value.toString()">
              @for (allowable of motorTypeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="motorTypeSelection.Value && motorTypeSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (motorSizeSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Size of Motor:</label>
            <select class="halfWidthInputField" #motorSizeInput
              [class.invalidConfigurationSelection]="isInvalidSelection(motorSizeSelection.Name)"
              (change)="selectionChanged(motorSizeSelection, motorSizeInput.value)"
              [value]="motorSizeSelection.Value.toString()">
              @for (allowable of motorSizeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="motorSizeSelection.Value && motorSizeSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (driveCodeLetterSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Drive Code Letter:</label>
            <select class="halfWidthInputField" #driveCodeLetterInput
              [class.invalidConfigurationSelection]="isInvalidSelection(driveCodeLetterSelection.Name)"
              (change)="selectionChanged(driveCodeLetterSelection, driveCodeLetterInput.value)"
              [value]="driveCodeLetterSelection.Value.toString()">
              @for (allowable of driveCodeLetterSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="driveCodeLetterSelection.Value && driveCodeLetterSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (driveCodeNumberSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Drive Code Number:</label>
            <select class="halfWidthInputField" #driveCodeNumberInput
              [class.invalidConfigurationSelection]="isInvalidSelection(driveCodeNumberSelection.Name)"
              (change)="selectionChanged(driveCodeNumberSelection, driveCodeNumberInput.value)"
              [value]="driveCodeNumberSelection.Value.toString()">
              @for (allowable of driveCodeNumberSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="driveCodeNumberSelection.Value && driveCodeNumberSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (numberOfTurnsSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Number of Turns:</label>
            <select class="halfWidthInputField" #numberOfTurnsInput
              [class.invalidConfigurationSelection]="isInvalidSelection(numberOfTurnsSelection.Name)"
              (change)="selectionChanged(numberOfTurnsSelection, numberOfTurnsInput.value)"
              [value]="numberOfTurnsSelection.Value.toString()">
              @for (allowable of numberOfTurnsSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="numberOfTurnsSelection.Value && numberOfTurnsSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
    </div>
  }
</div>
